"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = action;
exports._reader = _reader;
exports._writer = _writer;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

function action(target, key, descriptor) {
  var actionName = "".concat(target.table, ".").concat(key);
  return (0, _extends2.default)({}, descriptor, {
    value: function value(...args) {
      var _this = this;

      return this.database.action(function () {
        return descriptor.value.apply(_this, args);
      }, actionName);
    }
  });
} // (experimental rename)


function _reader(target, key, descriptor) {
  var actionName = "".concat(target.table, ".").concat(key, " (reader)");
  return (0, _extends2.default)({}, descriptor, {
    value: function value(...args) {
      var _this2 = this;

      return this.database._read(function () {
        return descriptor.value.apply(_this2, args);
      }, actionName);
    }
  });
} // (experimental rename)


function _writer(target, key, descriptor) {
  var actionName = "".concat(target.table, ".").concat(key, " (writer)");
  return (0, _extends2.default)({}, descriptor, {
    value: function value(...args) {
      var _this3 = this;

      return this.database._write(function () {
        return descriptor.value.apply(_this3, args);
      }, actionName);
    }
  });
}